import { Alert, Avatar, Badge, Button, notification, Tabs, Typography } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import BgImage from '../../../assets/images/react-js.jpg'
import { BookOutlined, CheckCircleOutlined, CommentOutlined, ExperimentOutlined, FileProtectOutlined, FileTextOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { CoursesSection } from '.'
import { Collapse } from "antd";
import axios from 'axios'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { __hideLoader, __showLoader } from '../../../Redux Store/Slices/loader'
import { courseEnrollmentByUserAndIdUrl, courseEnrollmentUrl, courseUrl, createOrderUrl } from '../../../urls'
import useCustomNotification from '../../../hooks/useCustomNotification'
import AboutTab from '../../../components/pageComponents/course-view/AboutTab'
import CourseModules from '../../../components/pageComponents/course-view/CourseModules'
import ScrollToTop from '../../../ScrollToTop'
import useErrorHandler from '../../../hooks/useErrorHandler'
import PlaylistList from '../../../components/PlaylistList'
const { Panel } = Collapse;

// const __DEV__ = document.domain === "localhost";

const CourseView = ({ isHomePage, defaultData = null }) => {

    const [courseData, setCourseData] = useState({});
    const [showDescMore, setShowDescMore] = useState(false)
    const params = useParams();
    const handleError = useErrorHandler();

    const id = params.id;

    console.log({ courseData })

    // const createOrderUrl = `/payment/create-order`;
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)
    const [orderId, setOrderId] = useState(null)
    const [api, contextHolder] = notification.useNotification();

    function enrollDirect(paymentId) {
        const payload = {
            userId: user.username,
            courseId: courseData?.course?.id,
            purchaseDate: new Date().toISOString().split("T")[0], // Current date
            price: courseData.course.price, // Static price (can be dynamic if needed)
            expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                .toISOString()
                .split("T")[0], // 1 year from now
            paymentId: paymentId,
        };

        console.log({ payload });

        dispatch(__showLoader("Enrolling..."));
        axios
            .post(courseEnrollmentUrl, payload)
            .then((res) => {
                navigate("/dashboard");
                // setTimeout(() => {
                //     window.location.reload();
                // }, 2000);

                // setCourses(res.data);
                api.info({
                    message: "Notification",
                    description: "Course Enrollment Successful!",
                    duration: 0,
                });
            })
            .catch((err) => {
                handleError(err);
            })
            .finally(() => {
                dispatch(__hideLoader());
            });
    }


    const handlePayment = async () => {
        try {
            dispatch(__showLoader("Opening RazorPay..."));
            const orderResponse = await axios.post(createOrderUrl, {
                "amount": courseData?.course?.price,
                "currency": "INR"
            });
            const orderData = orderResponse.data;
            // setOrderId(orderData?.orderId);
            let orderId = orderData?.orderId
            console.log({ orderId: orderData?.orderId });


            if (!orderData) {
                alert("Unable to create order");
                return;
            }

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: orderData.amount,
                currency: "INR",
                name: "Pronttera Labs",
                description: "Purchase Description",
                order_id: orderData.id,
                handler: function (response) {
                    // response contains paymentId, orderId, and signature
                    console.log({ response })
                    const { razorpay_payment_id, signature } = response;

                    console.log('Payment ID:', razorpay_payment_id);
                    console.log('Order ID:', orderId);
                    console.log('Signature:', signature);
                    api.success({
                        message: "Payment Successful",
                        description: `Payment ID: ${response.razorpay_payment_id}. Thank you for your purchase.`,
                        duration: 0,
                    });
                    enrollDirect(orderId);

                    // Now, you can verify the signature on the server
                    // Send paymentId, orderId, and signature to your server for verification
                },
                // handler: function (response) {
                //     // todo: Add course to user (student)

                //     // alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
                //     console.log({ handlerResponse: response });
                // },
                prefill: {
                    name: user.name,
                    email: user.email,
                    contact: user.phoneNumber,
                },
                theme: {
                    color: "#FEC107",
                },
            };

            console.log({ options })

            const razor = new window.Razorpay(options);
            razor.open();

            razor.on("payment.success", function (response) {
                api.open({
                    message: "Payment Successful",
                    description: "Thank you for your purchase.",
                    duration: 0,
                });
                console.log("Payment Successful! Thank you for your purchase.");
                console.log({ successResponse: response });
            });

            razor.on("payment.captured", function (response) {
                api.open({
                    message: "Payment Successful (Captured)",
                    description: "Thank you for your purchase.",
                    duration: 0,
                });
                console.log("Payment Successful! Thank you for your purchase.");
                console.log({ successResponse: response });
            });

            razor.on("payment.failed", function (response) {
                console.log({ responseData: response.data.status })

                api.open({
                    message: "Payment Failed",
                    description: "Please try again.",
                    duration: 0,
                });
                console.log("Payment Failed. Please try again.");
                console.log(response.error);
            });
        } catch (error) {
            api.open({
                message: "Payment Failed",
                description: "There was an error while processing the payment. Please try again.",
                duration: 0,
            });
            handleError(error);
            console.error("Error during payment handling:", error);
            console.log("There was an error while processing the payment. Please try again.");
        }
        finally {
            dispatch(__hideLoader())
        }
    };
    useEffect(() => {
        if (defaultData)
            setCourseData(defaultData)
    }, []);

    useEffect(() => {
        dispatch(__showLoader("Course Loading..."))
        axios.get(courseEnrollmentByUserAndIdUrl(id, user.username)).then(res => setCourseData(res.data)).catch(err => {
            console.log(err)
            api.open({
                message: "Something Went Wrong",
                description: "Please try again.",
                duration: 0,
            });
        }).finally(() => {
            dispatch(__hideLoader())
        })
    }, [])

    const paperData = [
        {
            title: `${courseData?.course?.modules?.length || 0} Modules`,
            description: 'Gain insight into a topic and learn the fundamentals.'
        },
        {
            title: `${courseData?.course?.difficulty} Level`,
            description: 'Recommended experience'
        },
        {
            title: 'Flexible schedule',
            description: `Approx. ${courseData?.course?.duration} hours
                        Learn at your own pace`
        },
        {
            title: '95%',
            description: 'Most learners liked this course'
        },
    ]
    console.log({ courseData })
    // if (courseData.name)
    return (
        <>
            <ScrollToTop />

            {contextHolder}
            <div className=""
                style={{
                    background: `url(${courseData?.course?.banner})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <section className='flex justify-between section bg-gradient-to-r from-black to-transparent md:!pb-24'
                    style={{
                        paddingTop: isHomePage ? '5rem' : ''
                    }}
                >
                    <div className='max-w-96 '>
                        {/* <div className="flex gap-4 items-center mb-4">

                                <Badge count='Udemy' />
                                <Badge count='Free' />
                            </div> */}
                        <div className="mb-4">
                            <Typography.Title className='!text-white' >{courseData?.course?.name}</Typography.Title>
                            <Typography.Text className={`!text-white ${showDescMore ? '' : 'line-clamp-3'}`} >{courseData?.description}</Typography.Text>
                            <p className="text-blue-500 cursor-pointer underline text-left" onClick={() => setShowDescMore(!showDescMore)} >{!showDescMore ? "Show More" : "Show Less"}</p>

                        </div>
                        <div className="flex flex-col gap-2">
                            <Typography.Text className='!text-white' >At ₹{courseData?.course?.price}</Typography.Text>
                            {/* <Button size='large' type='primary' onClick={() => {
                                if (isHomePage) {
                                    navigate('/signup')
                                }
                                else {
                                    handlePayment()
                                }
                            }} >Enroll Now</Button> */}
                        </div>
                    </div>
                    {/* <div className=""></div> */}

                </section>
            </div>
            <div className='max-w-[70rem] mx-auto md:mt-[-3rem] p-4'>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {paperData.map((paper, index) => (
                        <div
                            key={index}
                            className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white"
                        >
                            <Typography.Title level={4} className="!mb-2">
                                {paper.title}
                            </Typography.Title>
                            {/* <Typography.Text>
                                ₹{paper.amount}
                            </Typography.Text> */}
                            <Typography.Text className="text-gray-600">
                                {paper.description}
                            </Typography.Text>
                        </div>
                    ))}
                </div>
            </div>
            <section className="section mt-6">
                <Alert
                    message={<>
                        Join the Live Session on <a href={courseData?.course?.googleMeetsLink} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">Google Meet</a>.

                    </>}
                    description={
                        courseData?.course?.courseTiming
                    }
                    type="success"
                    showIcon
                />
                <div className="mt-6">
                    <Typography.Title level={4} >Previous Sessions</Typography.Title>
                    <PlaylistList playlistId={courseData?.course?.playlistId}
                    />
                </div>
            </section>

            <section className='section' >
                <CourseDataSectionTabs
                    modules={courseData?.course?.modules || []}
                    about={courseData?.course?.about}
                    tags={courseData?.course?.tags || []}
                    testimonials={courseData?.course?.testimonials || []}
                    trainers={courseData?.course?.trainers || []}
                />
            </section>

        </>

    )
}

export default CourseView;

const CourseDataSectionTabs = ({ modules, about = [], tags, testimonials, trainers }) => {
    console.log({ modules })
    console.log({ about });
    const items = about?.split?.("--- ")?.filter?.(a => !!a)
    console.log(items);
    const tabs = useMemo(() => [
        {
            id: 1,
            label: 'About',
            children: <AboutTab items={items} tags={tags} />,
        },
        {
            id: 2,
            label: 'Modules',
            children: <CourseModules modules={modules} trainers={trainers} />,
        },
        {
            id: 3,
            label: 'Testimonials',
            children: <Testimonials testimonials={testimonials} />,
        },
    ], [items, tags, modules]);

    const [activeKey, setActiveKey] = useState(String(tabs[0].id)); // Default to first tab

    const handleTabChange = (key) => {
        setActiveKey(key);
    };

    return (
        <Tabs
            // tabBarStyle={{
            //     position: 'sticky',
            //     top: 0,
            //     backgroundColor: '!white',
            //     zIndex: 99
            // }}
            // listStyle={{
            //     backgroundColor: 'white'
            // }}
            className='border-b border-b-slate-200  pb-8 mb-8'
            activeKey={activeKey}
            onChange={handleTabChange}
            items={tabs.map(({ id, label, children }) => ({
                key: String(id),
                label,
                children,
            }))}
        />
    );
};











const Testimonials = ({ testimonials }) => {
    return (
        <div className="bg-gray-100 py-10 px-6">
            {/* Headline Section */}
            <div className="mb-8 text-center">
                <h1 className="text-lg font-semibold mb-4">Hear from Our Learners</h1>
                <p className="text-lg text-gray-600">
                    See how our courses have transformed the careers of thousands of learners.
                </p>
            </div>

            {/* Conditional Rendering for Testimonials */}
            {testimonials?.length === 0 ? (
                <h2 className="text-2xl font-bold text-center mb-8">
                    No Testimonials
                </h2>
            ) : (
                <>
                    <h2 className="text-2xl font-bold text-center mb-8">
                        What Our Students Say
                    </h2>
                    <div className="flex flex-wrap justify-center gap-6">
                        {testimonials?.map((testimonial, index) => (
                            <div
                                key={index}
                                className="max-w-sm bg-white shadow-md rounded-lg p-6 border border-gray-200 text-center"
                            >
                                {testimonial.imgUrl !== "" ? <img
                                    src={testimonial?.imgUrl}
                                    alt={testimonial.reviewerName}
                                    className="w-24 h-24 object-cover mx-auto rounded-full mb-4"
                                /> : <Avatar style={{ backgroundColor: "#f56a00", verticalAlign: 'middle' }} size="large" gap={4}>
                                    {testimonial.reviewerName.split("")[0]}
                                </Avatar>}
                                <h3 className="font-semibold text-lg text-gray-700 mb-2">
                                    {testimonial.reviewerName}
                                </h3>
                                <p className="text-gray-600 italic">"{testimonial.review}"</p>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};


